export const FEEDBACK_STATUS_FILTERS = ["olost", "oppen", "pagar", "stangd", "alla"] as const;
export const FEEDBACK_TYPE_FILTERS = ["alla", "bug", "onskemal"] as const;
export const FEEDBACK_STATUSES = ["oppen", "pagar", "stangd"] as const;

export type FeedbackStatusFilter = (typeof FEEDBACK_STATUS_FILTERS)[number];
export type FeedbackTypeFilter = (typeof FEEDBACK_TYPE_FILTERS)[number];
export type FeedbackStatus = (typeof FEEDBACK_STATUSES)[number];
export type FeedbackType = Exclude<FeedbackTypeFilter, "alla">;

export function resolveFeedbackStatusFilter(value: string | null): FeedbackStatusFilter {
  return FEEDBACK_STATUS_FILTERS.includes(value as FeedbackStatusFilter)
    ? (value as FeedbackStatusFilter)
    : "olost";
}

export function resolveFeedbackTypeFilter(value: string | null): FeedbackTypeFilter {
  return FEEDBACK_TYPE_FILTERS.includes(value as FeedbackTypeFilter)
    ? (value as FeedbackTypeFilter)
    : "alla";
}

export function feedbackListApiPath(status: FeedbackStatusFilter, typ: FeedbackTypeFilter): string {
  const query = new URLSearchParams({ status, typ, limit: "100" });
  return `/admin/v1/feedback?${query.toString()}`;
}

export function feedbackStatusApiPath(id: string): string {
  return `/admin/v1/feedback/${encodeURIComponent(id)}/status`;
}

export function feedbackStatusLabel(status: FeedbackStatus | FeedbackStatusFilter): string {
  switch (status) {
    case "olost":
      return "Olösta";
    case "oppen":
      return "Öppna";
    case "pagar":
      return "Pågår";
    case "stangd":
      return "Stängda";
    case "alla":
      return "Alla";
  }
}

export function feedbackItemStatusLabel(status: FeedbackStatus): string {
  switch (status) {
    case "oppen":
      return "Öppen";
    case "pagar":
      return "Pågår";
    case "stangd":
      return "Stängd";
  }
}

export function feedbackTypeLabel(typ: FeedbackTypeFilter): string {
  switch (typ) {
    case "bug":
      return "Felanmälan";
    case "onskemal":
      return "Önskemål";
    case "alla":
      return "Alla typer";
  }
}
